import { render, staticRenderFns } from "./UserModule.vue?vue&type=template&id=663d0e00&"
import script from "./UserModule.vue?vue&type=script&lang=js&"
export * from "./UserModule.vue?vue&type=script&lang=js&"
import style0 from "./UserModule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports